import React, {Component} from "react";
import MomentUtils from "@date-io/moment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import moment from "moment/moment";


class ReleaseInput extends Component {
    state = {
        start_date: null,
        end_date: null
    };

    componentDidMount() {
        // console.log("Date picker - mounted")
        // this.props.releaseStartUpdate(moment(this.state.start_date).format('YYYY-MM-DD'));
        // this.props.releaseEndUpdate(moment(this.state.end_date).format('YYYY-MM-DD'));
    }

    render() {
        let releaseInput = null;

        const defaultEnd = (this.props.release_end_filter ? this.props.release_end_filter : null);
        const defaultStart = (this.props.release_start_filter ? this.props.release_start_filter : null);

        releaseInput = (
            <div>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                        variant="inline"
                        format="MM/DD/yyyy"
                        margin="none"
                        id="start-date"
                        label="Start Date"
                        value={(this.state.start_date ?? defaultStart)}
                        onChange={(val) => {
                            const retArr = (moment(val).format('YYYY-MM-DD') !== 'Invalid date')
                                ? (moment(val).format('YYYY-MM-DD')) : '';
                            console.log(retArr);
                            this.props.releaseStartUpdate(retArr);
                            this.props.updatePage(0);
                            this.props.closeGameDetails(null);
                            this.setState({start_date: val})
                        }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            variant="inline"
                            format="MM/DD/yyyy"
                            margin="none"
                            id="end-date"
                            label="End Date"
                            value={(this.state.end_date ?? defaultEnd)}
                            onChange={(val) => {
                                const retArr = (moment(val).format('YYYY-MM-DD') !== 'Invalid date')
                                    ? (moment(val).format('YYYY-MM-DD')) : '';
                                console.log(retArr);
                                console.log(val)
                                this.props.releaseEndUpdate(retArr);
                                this.props.updatePage(0);
                                this.props.closeGameDetails(null);
                                this.setState({end_date: val})
                            }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </div>
            );
        return releaseInput;
    }
}

export default ReleaseInput;